<template>
    <div class="page-container">
        <div class="page-top">
            <div class="card-block">
                <div class="total-stock">
                    <div>
                        <div class="stock-number" :hidden="!totalStockSee">395.92 <van-icon class="eye-icon" color="#fff" size="26" name="eye-o" @click="toggleSee" /></div>
                        <div class="stock-number" :hidden="totalStockSee">* * * <van-icon class="eye-icon" color="#fff" size="26" name="closed-eye" @click="toggleSee" /></div>
                        <div class="stock-text">已获总奖励</div>
                    </div>
                    <div class="reward-rules">奖励政策</div>
                </div>
                <div class="prize-list">
                    <div class="prize-item">
                        <div class="prize-number">182</div>
                        <div class="prize-text">
                            已获销售奖
                        </div>
                    </div>
                    <div class="prize-item">
                        <div class="prize-number">100</div>
                        <div class="prize-text">已获推荐奖</div>
                    </div>
                    <div class="prize-item">
                        <div class="prize-number">86</div>
                        <div class="prize-text">待获销售奖</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-bottom">
            <div class="reward-tab">
                <div class="tab-item" :class="{actived : currentTab == 0}" @click="changeTab(0)">推荐奖励</div>
                <div class="tab-item" :class="{actived : currentTab == 1}" @click="changeTab(1)">销售奖励</div>
            </div>
            <div class="reward-list">
                <div class="reward-item">
                    <div class="item-top">
                        <span>推荐奖励</span>
                        <span>+0.66</span>
                    </div>
                    <div class="item-bottom">
                        <span>2020-11-20</span>
                        <span>来自：微信</span>
                    </div>
                </div>
                <div class="reward-item">
                    <div class="item-top">
                        <span>推荐奖励</span>
                        <span>+0.66</span>
                    </div>
                    <div class="item-bottom">
                        <span>2020-11-20</span>
                        <span>来自：微信</span>
                    </div>
                </div>
                <div class="see-more">查看更多</div>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from 'vant'

export default {
    data(){
        return {
            totalStockSee:true,
            currentTab:0,//0 推荐奖励，1 销售奖励
        }
    },
    components:{
        [Icon.name]:Icon
    },
    methods:{
        toggleSee(){
            this.totalStockSee=!this.totalStockSee;
        },
        changeTab(type){
            this.currentTab=type;
        }
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    .page-top{
        background:#fff;
        padding:15px;
        .card-block{
            height:160px;
            background: linear-gradient(320deg, #3CA7FE 0%, #3088F5 100%);
            color:#fff;
            box-sizing: border-box;
            padding:20px;
            @media screen and (max-width: 750px){
                border-radius: 6px;
            }
            .total-stock{
                color:#fff;
                font-weight: bold;
                margin-bottom: 20px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .stock-number{
                    font-family: DINAlternate-Bold, DINAlternate;
                    line-height: 36px;
                    margin-bottom: 4px;
                    font-size: 30px;
                }
                .stock-text{
                    line-height: 18px;
                    font-size: 14px;
                }
                .reward-rules{
                    color:#fff;
                    line-height: 18px;
                    font-size: 14px;
                }
            }
            .prize-list{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
                .prize-item{
                    width:33%;
                    color:#fff;
                    .prize-number{
                        font-weight: bold;
                        font-family: DINAlternate-Bold, DINAlternate;
                        line-height: 22px;
                        margin-bottom: 4px;
                        font-size: 18px;
                    }
                    .prize-text{
                        line-height: 18px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .page-bottom{
        padding:10px;
        .reward-tab{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .tab-item{
                width:160px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:#e6e6e6;
                font-size: 14px;
                position: relative;
                @media screen and (max-width: 750px){
                    border-radius: 6px 6px 0px 0px;
                }
                z-index: 1;
                &:first-child{
                    &::after{
                        content:'';
                        display: block;
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 36px 0 0 20px;
                        border-color: transparent transparent transparent #e6e6e6;
                        position: absolute;
                        right:-20px;
                        bottom:0;
                    }
                }
                &:last-child{
                    &::after{
                        content:'';
                        display: block;
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 0 0 36px 20px;
                        border-color: transparent transparent #e6e6e6 transparent;
                        position: absolute;
                        left:-20px;
                        bottom:0;
                    }
                }
                &.actived{
                    background:#fff;
                    color:#3088F5;
                    z-index: 2;
                    &:first-child{
                        &::after{
                            border-color: transparent transparent transparent #fff;
                        }
                    }
                    &:last-child{
                        &::after{
                            border-color: transparent transparent #fff transparent;
                        }
                    }
                }
            }
        }
        .reward-list{
            padding:0 20px;
            background:#fff;
            height:calc(100vh - 46px - 250px);
            overflow-y: auto;
            .reward-item{
                padding:10px 0;
                border-bottom: 1px solid #f9f9f9;
                .item-top{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    line-height: 20px;
                    font-size: 16px;
                    margin-bottom: 4px;
                    span{
                        &:first-child{
                            color:#333;
                        }
                        &:last-child{
                            color:#3088F5;
                        }
                    }
                }
                .item-bottom{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 12px;
                    color:#999;
                }
            }
        }
        .see-more{
            text-align: center;
            font-size: 12px;
            color:#999;
            line-height: 40px;
            height:40px;
        }
    }
}
</style>